
<template>
   <div id="splash-screen" class="splash-screen">
    <div class="loader"></div>
</div>
  
</template>

<script>
export default {
  name: 'Loading',
  created() {

  },
  data() {
    return {
    }
  },
  props: {
   
  },
  methods: {
   
  },
}
</script>

<style lang="scss" scoped>

</style>

